import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiSave, FiCalendar, FiMapPin, FiClock } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { reuniaoJovensService, congregacaoService } from '../../services/api';
import './ReuniaoJovens.css';

const ReuniaoJovensNova = () => {
  const navigate = useNavigate();
  const [congregacoes, setCongregacoes] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [form, setForm] = useState({
    dataReuniao: '', congregacaoNome: '', horario: '10:00', observacoes: '',
  });

  useEffect(() => {
    congregacaoService.getAtivas().then((r) => {
      const lista = (r?.data || []).map((c) => ({
        id: c.id, nome: c.nome || c.nomeCompleto,
      })).filter((c) => c.nome);
      setCongregacoes(lista);
    }).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.dataReuniao || !form.congregacaoNome) {
      toast.warn('Preencha data e congregação');
      return;
    }
    try {
      setSalvando(true);
      const cong = congregacoes.find((c) => c.nome === form.congregacaoNome);
      const resp = await reuniaoJovensService.criar({
        ...form,
        congregacaoId: cong?.id || null,
      });
      toast.success('Reunião criada!');
      navigate(`/reuniao-jovens/${resp.data.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Erro ao criar reunião');
    } finally {
      setSalvando(false);
    }
  };

  return (
    <div className="rj-page">
      <button className="rj-back" onClick={() => navigate('/reuniao-jovens')}>
        <FiArrowLeft /> Voltar
      </button>

      <header className="rj-page-header">
        <div>
          <h1><FiCalendar className="rj-icon-title" /> Nova reunião</h1>
          <p>Cadastre uma reunião de jovens manualmente</p>
        </div>
      </header>

      <form className="rj-section" onSubmit={submit}>
        <div className="rj-form-grid">
          <label>
            <span><FiCalendar /> Data</span>
            <input
              type="date"
              value={form.dataReuniao}
              onChange={(e) => setForm({ ...form, dataReuniao: e.target.value })}
              required
            />
          </label>

          <label>
            <span><FiMapPin /> Congregação</span>
            <select
              value={form.congregacaoNome}
              onChange={(e) => setForm({ ...form, congregacaoNome: e.target.value })}
              required
            >
              <option value="">Selecione…</option>
              {congregacoes.map((c) => <option key={c.id} value={c.nome}>{c.nome}</option>)}
            </select>
          </label>

          <label>
            <span><FiClock /> Horário</span>
            <input
              type="time"
              value={form.horario}
              onChange={(e) => setForm({ ...form, horario: e.target.value })}
            />
          </label>
        </div>

        <label className="rj-form-full">
          <span>Observações</span>
          <textarea
            rows={3}
            value={form.observacoes}
            onChange={(e) => setForm({ ...form, observacoes: e.target.value })}
          />
        </label>

        <div className="rj-action-bar">
          <button type="submit" className="rj-btn rj-btn-primary" disabled={salvando}>
            <FiSave /> {salvando ? 'Salvando…' : 'Criar reunião'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ReuniaoJovensNova;
